'use client';

import { Button } from '@mui/material';

import { AbgTypography, mergeSx, useTranslation } from '@abg/kit-base';

import { submitMfaFormFooterStyling as styling } from './SubmitMfaFormFooter.styling';
import { SubmitMfaFormFooterProps } from './types';

export const SubmitMfaFormFooter = ({ model }: SubmitMfaFormFooterProps) => {
  const t = useTranslation(model.i18n);

  return (
    <Button
      data-testid="mfa-dialog-submit-button"
      type="submit"
      variant="outlined"
      form="submit-mfa-form"
      sx={mergeSx(styling.confirmBtn)}
    >
      <AbgTypography component="span">
        {t('global.button.continue.label')}
      </AbgTypography>
    </Button>
  );
};
